import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isAfter, isBefore } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class FormValidationService {
  constructor() {}

  shouldNotStartWithSpace(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value || '') as string;
      return value != '' && value?.startsWith(' ')
        ? {
            startsWithSpace: true,
            errorMessage: 'This field cannot start with space.',
          }
        : null;
    };
  }

  shouldContainOnlyAlphabets(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value || '') as string;
      return !/^[a-zA-Z]*[a-zA-Z]*\.?$/.test(value)
        ? {
            doesNotContainOnlyAlphabets: true,
            errorMessage: 'This field should only contain alphabets.',
          }
        : null;
    };
  }

  shouldContainOnlyEmail(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value || '') as string;
      return value != '' &&
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
        ? {
            doesNotContainOnlyEmail: true,
            errorMessage: 'This field should only contain email.',
          }
        : null;
    };
  }

  shouldContainOnlyAlphabetsAndNumbers(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value || '') as string;
      return !/^[a-zA-Z0-9]+$/.test(value)
        ? {
            doesNotContainOnlyAlphabetsAndNumbers: true,
            errorMessage:
              'This field should only contain alphabets and numbers.',
          }
        : null;
    };
  }

  shouldContainOnlyFourNumbers(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value || '') as string;
      return !/\d{4}$/.test(value) || value === '0000'
        ? {
            doesNotContainOnlyFourNumbers: true,
            errorMessage:
              'This field cannot contain space and should only contain four digit number (excluding 0000).',
          }
        : null;
    };
  }

  shouldContainDatesAfterToday(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value || '') as string;
      return null;
      // test

      const sanitizedValue = new Date(value);

      if (
        !(sanitizedValue instanceof Date) ||
        isNaN(sanitizedValue.getTime())
      ) {
        return null;
      }

      return {
        doesNotContainDatesAfterToday: isAfter(new Date(), sanitizedValue),
        errorMessage: 'This field should only contain dates before today.',
      };
    };
  }

  shouldContainDatesBeforeToday(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value || '') as string;
      return null;

      const sanitizedValue = new Date(value);

      if (
        !(sanitizedValue instanceof Date) ||
        isNaN(sanitizedValue.getTime())
      ) {
        return null;
      }

      return {
        doesNotContainDatesBeforeToday: isBefore(new Date(), sanitizedValue),
        errorMessage: 'This field should only contain dates before today.',
      };
    };
  }
}
